import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [tasks, setTasks] = useState([]);
  const navigate = useNavigate();

  // Fetch and sort tasks
  const fetchTasks = async () => {
    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/get_tasks.php");
      const data = await response.json();

      // Sorting logic
      const sortedTasks = data.sort((a, b) => {
        if (b.client_flag !== a.client_flag) {
          return b.client_flag - a.client_flag;
        }
        if (b.weightage !== a.weightage) {
          return b.weightage - a.weightage;
        }
        if (a.deadline !== b.deadline) {
          return a.deadline - b.deadline;
        }
        if (a.day_to_schedule !== b.day_to_schedule) {
          return a.day_to_schedule - b.day_to_schedule;
        }
        return new Date(a.timestamp) - new Date(b.timestamp);
      });

      setTasks(sortedTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  // Fetch tasks on component mount
  useEffect(() => {
    fetchTasks();
  }, []);

  return (
<div className="homecontainer">
  <button onClick={() => navigate("/login")}>Admin</button>
  <h2>RAK Task List</h2>

  {tasks.length === 0 ? (
    <p>No tasks available</p>
  ) : (
    <div className="home">
    <table className="home-table">
      <thead>
        <tr>
          <th>Task</th>
          <th>Weightage</th>
          <th>Deadline</th>
          <th>Schedule</th>
          <th>Client Flag</th>
        </tr>
      </thead>
      <tbody>
        {tasks.map((task) => (
          <tr key={task.tasks}>
            <td>{task.tasks}</td>
            <td>{task.weightage}</td>
            <td>{task.deadline}</td>
            <td>{task.day_to_schedule}</td>
            <td>{task.client_flag}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  )}
</div>

  );
};

export default Home;
